<template>
  <UtdBanner class="gdpr-cookie-banner">
    <template #text>
      <p class="ds1-utd-weight-500">
        {{ GDPR_COOKIE_BANNER_MESSAGE }}
      </p>
    </template>
    <template #buttons>
      <UtdButton id="acceptButton"
                 button-size="large"
                 button-color="green-shade-3"
                 @click="storeCookieConsent">
        Continue
      </UtdButton>
      <UtdButton id="learnMoreButton"
                 button-size="large"
                 button-style="text"
                 button-icon-position="right"
                 button-icon="arrow-right"
                 @click="navigateToPolicy">
        <span class="learn-more-text">
          Or, find out more
        </span>
      </UtdButton>
    </template>
  </UtdBanner>
</template>

<script setup lang="ts">
import UtdBanner from '_acaSrc/components/shared/utd/UtdBanner.vue';
import { GDPR_COOKIE_BANNER_MESSAGE } from '_acaSrc/utility/constants';
import UtdButton from '_acaSrc/components/shared/stdlib/UtdButton.vue';
import { getDocument, getWindow } from '_acaSrc/utility/DOM';
import { setCookie } from '_acaSrc/utility/Cookies';

const GDPR_COOKIE_EXPIRE_DAYS = 400;

const emit = defineEmits([ 'cookie-accept' ]);

const storeCookieConsent = () => {
    setCookie('cookie-accept', 't', {
        path: '/',
        expires: GDPR_COOKIE_EXPIRE_DAYS,
        domain: getDocument().location.hostname,
        secure: true,
        sameSite: ''
    });
    emit('cookie-accept');
};

const navigateToPolicy = () => {
    getWindow().open('/home/privacy-policy', '_blank');
};
</script>

<style lang="less" scoped>
@import (reference) '~_acaAssets/wkce/colors/wkce-app-styles';

@media only screen and (min-width: 768px) {
  :deep(.banner-content) {
    .ds1-ph-3();
  }
}

.gdpr-cookie-banner {
  .ds1-flex-horizontal-center();
  color: @DS1-LIGHT-ON-DARK-FONT-COLOR;
}

#learnMoreButton {
  .learn-more-text {
    color: @DS1-LIGHT-ON-DARK-FONT-COLOR;
  }

  :deep(.utd-button-icon) {
    color: @WKCE-GREEN;

    &:hover {
      color: @WKCE-GREEN-SHADE3;
    }
  }
}
</style>